<s1-input-label [label]="label" [grouped]="grouped">
  <input type="range" [formControl]="control" [max]="maxValue" [attr.disabled]="readonly ? true : null" class="form-control-range">
</s1-input-label>